import { ChannelEnum } from "./enums";

export const getChannelCost = (channel: ChannelEnum | null): number => {
  switch (channel) {
    case ChannelEnum.WhatsAppStandard:
      return Number(process.env.REACT_APP_WHATSAPP_COST) || 0;

    case ChannelEnum.WhatsAppPremium:
      return Number(process.env.REACT_APP_WHATSAPP_PREMIUM_COST) || 0;

    case ChannelEnum.Sms:
      return Number(process.env.REACT_APP_SMS_COST) || 0;

    case ChannelEnum.Email:
      return Number(process.env.REACT_APP_EMAIL_COST) || 0;

    default:
      return 0;
  }
};
